import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-component-button-square',
  templateUrl: './component-button-square.component.html',
  styleUrls: ['./component-button-square.component.scss'],
})
export class ComponentButtonSquareComponent implements OnInit {

  @Input() text: string;
  @Input() iconName: string;
  constructor() { }

  ngOnInit() {}

}
